/**
 * TipTap ImageResize serializes layout as non-standard img attributes
 * (wrapperstyle, containerstyle). Browsers ignore those, so we merge them
 * into a real style attribute for v-html article rendering.
 */
function mergeCssDecls(...chunks) {
  const map = new Map()
  for (const chunk of chunks) {
    if (!chunk || typeof chunk !== 'string') continue
    for (const raw of chunk.split(';')) {
      const idx = raw.indexOf(':')
      if (idx === -1) continue
      const prop = raw.slice(0, idx).trim().toLowerCase()
      const val = raw.slice(idx + 1).trim()
      if (prop && val) map.set(prop, val)
    }
  }
  return [...map.entries()].map(([k, v]) => `${k}: ${v}`).join('; ')
}

export function flattenNewsImagesForDisplay(html) {
  if (!html || typeof document === 'undefined') return html
  const wrap = document.createElement('div')
  wrap.innerHTML = html
  wrap.querySelectorAll('img').forEach((img) => {
    const w = img.getAttribute('wrapperstyle')
    const c = img.getAttribute('containerstyle')
    if (!w && !c) return
    const merged = mergeCssDecls(w || '', c || '')
    const prev = img.getAttribute('style') || ''
    img.setAttribute('style', mergeCssDecls(prev, merged))
    img.removeAttribute('wrapperstyle')
    img.removeAttribute('containerstyle')
  })
  return wrap.innerHTML
}
